export default {
  props: ["suborder", "order"],
};
